import { message } from "antd";
import { t } from "@lingui/macro";
import { getMsgType } from "../../redux/Transaction/helper";
import { normalizeAutosaveData } from "../../redux/Transaction/helpers/normalizeAutosaveData";
import { writeAutosaveStorage } from "../../redux/LocalStorage/helpers/AutosaveTransactions/writeStorage";

export const AutosaveHelper = {
    isModified: (transactionType, autosaveData, hasChanges, autosaveProps, storageProps) => {
        const {
            // checkAutosave: isAutosave,
            currentTime: lastSavedTime,
            isOnPageChange,
            hasAnyChange,
            action,
        } = autosaveProps;

        const {
            currentData,
            files,
            additionalProps, // eg form_summary_total, linked_items from invoices. Will be passed from invoices, bills and sales/purchase CN
            ...restProps
        } = storageProps;

        let mustSave;
        // if has action, eg PAY, and local storage don't have this data, save this new data
        if (action && !autosaveData)
            mustSave = true;

        // if since last autosave there has been no new changes, and user has not made ANY changes
        // to the txn at all, can return.
        // !hasAnyChange is because we want to trigger message.info if there are any changes at all.
        else if (!hasChanges && !hasAnyChange)
            return false;

        if (hasChanges || isOnPageChange || mustSave) {
            if (hasChanges || mustSave) {
                const storageItem = {};

                // files = [{
                //     file: {id, filename, mime_type, size},
                //     file_id, index, is_shared
                // }, ...]
                storageItem.data = {
                    ...currentData,
                    files,
                    ...additionalProps,
                };
                storageItem.last_saved = lastSavedTime;

                normalizeAutosaveData(transactionType, storageItem.data, {...restProps});

                // save the data into local storage
                writeAutosaveStorage(transactionType, storageItem);
            }
            if (isOnPageChange)
                message.info(t`The ${getMsgType(transactionType)} is autosaved and can be restored later.`);

            return true;
        }
        return false;
    },
};
